import storeManager from '../../store/StoreManager';
import appParameters from '../../components/utils/AppParameters';
import shapeTypes from '../../constants/ShapeConstants';
import configuration from '../../constants/Configuration';
import apiService from '../../services/ApiService';
import apiServiceUtils from '../utils/ApiServiceUtils';
import platformDetection from '../utils/PlatformDetection';
import transitionsUtils from '../utils/TransitionsUtils';
import drawingUtils from '../utils/DrawingUtils';
import colorUtils from '../utils/ColorUtils';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import textSizeUtils from '../utils/TextSizeUtils';
import speakBubbleUtils from '../../components/slide/shapes/utils/SpeakBubbleUtils';
import screamBubbleUtils from '../../components/slide/shapes/utils/ScreamBubbleUtils';
import thoughtBubbleUtils from '../../components/slide/shapes/utils/ThoughtBubbleUtils';
import playController from './PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import saveManager from './SaveManager';
import exportUploader from './ExportUploader';
import videoUtils from './VideoUtils';
import animationManager from "./AnimationManager";

const exporterUtils = {
    slides: [],
    videoIds: [],
    videoMap: [],
    storySound: undefined,
    checkStatusTimer: undefined,
    jobId: '',
    timelines: undefined,
    CANVAS_WIDTH: configuration.CANVAS_WIDTH,
    CANVAS_HEIGHT: configuration.CANVAS_HEIGHT,
    ANIMATION_SCALE_OFFSET: 10,
    testLocalAnimation: false,

    init() {
        exportUploader.init();
        this.setExportFlag(false);
        window.addEventListener('message', this.onExport.bind(this));
    },
    removeEvent() {
        window.removeEventListener('message', this.onExport);
    },
    startExport() {
        this.setExportFlag(true);
        this.onExport();
    },
    setExportFlag(value) {
        return; // removed functionality for the moment.
        if (appParameters.contentItemId < 0)
            return;

        if (!platformDetection.isIOS()) {
            if (value)
                localStorage.setItem('isExportStarted_' + appParameters.contentItemId, 'true');
            else
                localStorage.setItem('isExportStarted_' + appParameters.contentItemId, 'false');
        }
    },
    onExport(event) {
        if (event && event.data)
            transitionsUtils.exportPropertiesFromPortal = event.data;

        this.jobId = -1;
        apiServiceUtils.executeSafeApiCall(this.prepareDataForExport.bind(this), this.exportFailed.bind(this));
    },
    callExportJob(data) {
        var submitId = appParameters.submitId;

        var self = this;
        var totalTime = audioEditorUtils.getExportTotalTime();

        apiService.exportCartoonist(submitId, data, totalTime)
            .then(response => {
                if (response.jobId && response.jobId.length > 0) {
                    self.startCheckStatus(response.jobId, response.exportEstimation);
                } else {
                    self.exportFailed();
                }
            });
    },
    stopTimer() {
        if (this.checkStatusTimer)
            clearInterval(this.checkStatusTimer);
    },
    isPlayer() {
        if (appParameters.getMode() == modeType.PLAYER || appParameters.getMode() == modeType.AUDIO_TOOL_PLAYER)
            return true;
        else
            return false;
    },
    startCheckStatus(jobId, duration = 10 * 1000) {
        if (this.isPlayer()) {
            if (platformDetection.isIOSApp())
                window.parent.setExportDuration(duration);
            else
                window.parent.postMessage(duration, '*');
        }

        this.jobId = jobId;
        this.stopTimer();
        this.checkStatusTimer = setInterval(this.onCheckStatus.bind(this), 10 * 1000);
    },
    onCheckStatus() {
        if (!(this.jobId && this.jobId.length > 0)) {
            this.exportFailed();
            return;
        }

        var self = this;

        apiServiceUtils.executeSafeApiCall(function() {
            apiService.getExportStatus(this.jobId)
                .then(response => {
                    var contentItemId = response.contentItemId;

                    if (contentItemId > 0)
                        self.exportFinished(contentItemId);
                });
        }.bind(this), this.exportFailed.bind(this));
    },
    exportFinished(contentItemId) {
        this.setExportFlag(false);
        this.stopTimer();

        if (this.isPlayer()) {
            if (platformDetection.isIOSApp())
                window.parent.exportDoneCallback();
            else
                window.parent.postMessage('exportDone', '*');
        }
    },
    exportFailed() {
        this.setExportFlag(false);
        this.stopTimer();

        if (this.isPlayer()) {
            if (platformDetection.isIOSApp())
                window.parent.exportDoneCallback();
            else
                window.parent.postMessage('exportFailed', '*');
        }
    },
    prepareDataForExport() {
        if (audioToolUtils.isAudioTool()) {
            this.getTimelines();
            this.export();
        } else {
            this.slides = [];
            this.videoIds = [];
            this.videoMap = [];
            this.storySound = undefined;

            this.createSlideElements();

            var self = this;

            if (this.videoIds && this.videoIds.length > 0) {
                apiService.getVideoOriginals(this.videoIds)
                    .then(response => {
                        self.createVideoMap(response);
                    });
            } else {
                this.export();
            }
        }
    },
    export() {
        var data;

        if (audioToolUtils.isAudioTool())
            data = this.createAudioXML();
        else
            data = this.createXML();

        if (this.isBigData(data)) { // it's a big export so upload the xml to s3
            var jsonData = {};
            jsonData.xml = data;
            jsonData = JSON.stringify(jsonData);

            var blob = new Blob([jsonData], {type: 'application/json'});

            this.exportTitle = saveManager.getFileName();
            exportUploader.uploadFile(blob, this.exportTitle);
        } else
            this.callExportJob(data);
    },
    /***************** Big Export Data *********************/
    exportTitle: '',
    isBigData(data) {
        if (data && data.length > 900000)
            return true;
        else
            return false;
    },
    uploadSuccess(type, name, state) {
        if (state && state.success == true) {
            this.doBigExport();
        } else { // error: the file wasn't stored on s3
            this.uploadError();
        }
    },
    uploadError() {
        alert('Export fail!');
    },
    doBigExport() {
        var bucket;

        if (configuration.IS_PROD() == true)
            bucket = 'creaza-content-json';
        else
            bucket = 'creaza-stage-content-json';

        var data = 'https://s3-eu-west-1.amazonaws.com/' + bucket + '/Cartoonist/' + appParameters.currentUserId + '/export/' + this.exportTitle;

        this.callExportJob(data);
    },
    /*********************************************************/

    getDurationMap(slides) {
        let slideDuration = [];
        let correctMap = [];
        let i=0;
        let useTransitions = transitionsUtils.useTransitions();
        let prop;

        for (i=0; i<slides.length; i++)
            slideDuration.push(Math.floor(slides[i].time * 1000));

        if (!useTransitions || slides.length < 2) {
            for (i=0; i<slides.length; i++) {
                prop = {};
                prop.duration = slideDuration[i];
                prop.addTransition = false;

                correctMap.push(prop);
            }

            return correctMap;
        }

        for (i=0; i<slides.length; i++) {
            prop = {};
            prop.duration = slideDuration[i];

            if (i === slides.length - 1) // the last slide doesn't have transition
                prop.addTransition = false;
            else
                prop.addTransition = true;

            correctMap.push(prop);
        }

        return correctMap;
    },
    getPosition(duration, start, end, scaleFactor, position) {
        var totalTime = duration + start + end;

        return (scaleFactor * position) / totalTime;
    },
    addKenBurns(duration) {
        let scaleFactor = 0.1; // the scale difference between start and end position
        let min = 0;
        let max = 1;
        let noScaleTransition = Math.floor(Math.random() * (max - min + 1)) + min;
        let transitionType;
        let startTransitionTime = 0;
        let endTransitionTime = 0;

        if (noScaleTransition == 0) {
            max = 7;
            transitionType = Math.floor(Math.random() * (max - min + 1)) + min;

            var exportWidth = 1920;
            var exportHeight = 1080;
            var scale = 1 + scaleFactor;
            var startWidth = Math.floor(exportWidth * scale);
            var endWidth = startWidth;
            var startHeight = Math.floor(exportHeight * scale);
            var endHeight = startHeight;
            var startTop = -1 * (startHeight - exportHeight) / 2;
            var endTop = startTop;
            var startLeft = 0;
            var endLeft = -1 * (startWidth - exportWidth);
            var widthDifference = startWidth - exportWidth;
            var heightDifference = startHeight - exportHeight;
            var startXOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, widthDifference, startTransitionTime);
            var endXOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, widthDifference, endTransitionTime);
            var startYOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, heightDifference, startTransitionTime);
            var endYOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, heightDifference, endTransitionTime);

            endXOffset = endXOffset + startXOffset;
            endYOffset = endYOffset + startYOffset;

            switch (transitionType) {
                case 0: { // N-S
                    startTop = -heightDifference + startYOffset;
                    endTop = 0 - endYOffset;

                    startLeft = -widthDifference / 2;
                    endLeft = -widthDifference / 2;
                    break;
                }
                case 1: { // S-N
                    startTop = 0 - startYOffset;
                    endTop = -heightDifference + endYOffset;

                    startLeft = -widthDifference / 2;
                    endLeft = -widthDifference / 2;
                    break;
                }
                case 2: { // E-W
                    startTop = -heightDifference / 2;
                    endTop = -heightDifference / 2;

                    startLeft = 0 - startXOffset;
                    endLeft = -widthDifference + endXOffset;
                    break;
                }
                case 3: { // W-E
                    startTop = -heightDifference / 2;
                    endTop = -heightDifference / 2;

                    startLeft = -widthDifference + startXOffset;
                    endLeft = 0 - endXOffset;
                    break;
                }
                case 4: { // NE-SW
                    startTop = -heightDifference + startYOffset;
                    endTop = 0 - endYOffset;

                    startLeft = 0 - startXOffset;
                    endLeft = -widthDifference + endXOffset;
                    break;
                }
                case 5: { // SW-NE
                    startTop = 0 - startYOffset;
                    endTop = -heightDifference + endYOffset;

                    startLeft = -widthDifference + startXOffset;
                    endLeft = 0 - endXOffset;
                    break;
                }
                case 6: { // NW-SE
                    startTop = -heightDifference + startYOffset;
                    endTop = 0 - endYOffset;

                    startLeft = -widthDifference + startXOffset;
                    endLeft = 0 - endXOffset;
                    break;
                }
                case 7: { // SE-NW
                    startTop = 0 - startYOffset;
                    endTop = -heightDifference + endYOffset;

                    startLeft = 0 - startXOffset;
                    endLeft = -widthDifference + endXOffset;
                    break;
                }
            }

            return '<filter startWidth="' + startWidth + '" endWidth="' + endWidth + '" startHeight="' + startHeight + '" endHeight="' + endHeight + '" startTop="' + startTop + '" endTop="' + endTop + '" startLeft="' + startLeft + '" endLeft="' + endLeft + '" type="kenBurns"/>';
        } else {
            max = 17;
            transitionType = Math.floor(Math.random() * (max - min + 1)) + min;

            var type = 'scale';
            var start;
            var end;
            var gravity = 'Center';

            if (transitionType % 2 == 0) { // zoom out -- decrease zoom
                start = (scaleFactor + 1) - this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime);
                end = (scaleFactor + 1) - this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime + duration);
            } else { // zoom in -- increase zoom
                start = 1 + this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime);
                end = 1 + this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime + duration);
            }

            switch (transitionType) {
                case 0:
                case 1: {
                    gravity = 'NorthWest';
                    break;
                }

                case 2:
                case 3: {
                    gravity = 'North';
                    break;
                }

                case 4:
                case 5: {
                    gravity = 'NorthEast';
                    break;
                }

                case 6:
                case 7: {
                    gravity = 'West';
                    break;
                }

                case 8:
                case 9: {
                    gravity = 'Center';
                    break;
                }

                case 10:
                case 11: {
                    gravity = 'East';
                    break;
                }

                case 12:
                case 13: {
                    gravity = 'SouthWest';
                    break;
                }

                case 14:
                case 15: {
                    gravity = 'South';
                    break;
                }

                case 16:
                case 17: {
                    gravity = 'SouthEast';
                    break;
                }
            }

            return '<animation type="' + type + '" startValue="' + start + '" endValue="' + end + '" gravity="' + gravity + '"/>';
        }
    },
    getHtmls() {
        const slides = this.slides;
        var i;
        var slidesLayers = [];
        var maxLayers = 0;

        for (i=0; i<slides.length; i++) {
            var content = this.getHtmlForSlide(slides[i]);

            if (content.htmls.length > maxLayers)
                maxLayers = content.htmls.length;

            slidesLayers.push(content);
        }

        return {content: slidesLayers, maxLayers: maxLayers};
    },
    createXML() {
        let data = '<timeline version="1"><layers>';
        const slides = this.slides;
        let slide;
        let i;
        let j;
        let hasSlideSounds = false;
        let hasSlideSoundEffect = false;
        let hasVideoBackground = false;
        let totalTime = 0;
        let isAudioEditor = playController.isAudioEditorAvailable();
        let duration;
        let transitions = [];
        let useKenBurns = transitionsUtils.useKenBurns();
        let durationMap = this.getDurationMap(slides);
        let contentForSlides = this.getHtmls();
        let slidesLayers = contentForSlides.content;
        let maxLayers = contentForSlides.maxLayers;
        let htmlsForSlide;
        let animationsForSlide;
        let animatedShapesFromSlide;
        let currentTime = 0;

        for (i=0; i<slides.length; i++) {
            duration = durationMap[i].duration;
            totalTime = totalTime + duration;

            transitions.push(transitionsUtils.getTransition());
        }

        /****************** Animation layers: at least one is default(the main layer with htmls) if there is no animation ************************************************/
        if (maxLayers > 1) {
            data = data + '<!-- ********** Animation layers ******* -->';

            for (j=maxLayers-1; j>0; j--) {
                data = data + '<layer>';

                currentTime = 0;

                // for j layer parse all slides and add correct content
                for (i=0; i<slides.length; i++) {
                    slide = slides[i];
                    let slideDuration = durationMap[i].duration;

                    htmlsForSlide = slidesLayers[i].htmls;
                    animationsForSlide = slidesLayers[i].animations;
                    animatedShapesFromSlide = slidesLayers[i].animatedShapes;

                    if (htmlsForSlide.length - 1 >= j) { // a layer from a slide should be added to the current layer
                        if (animationsForSlide[j] !== 0) {
                            var animation = animationsForSlide[j];
                            let animationPoints = animationManager.getAnimationPoints(animation);

                            for (let k=0; k<animationPoints.length - 1; k++) {
                                let slideDurationPerAnimation = animationPoints.length === 2 ? slideDuration : Math.floor(slideDuration / (animationPoints.length - 1));
                                let currentTimePerAnimation = animationPoints.length > 2 ? (currentTime + slideDurationPerAnimation * k) : currentTime;
                                let startAnimation = animationPoints[k];
                                let endAnimation = animationPoints[k + 1];
                                let originalShape = animatedShapesFromSlide[j];
                                let currentHtmlForSlide = (k > 0) ? this.getHtmlFromAnimation(originalShape, startAnimation) : htmlsForSlide[j];

                                data = data + '<html begin="' + Math.floor(currentTimePerAnimation) + '" duration="' + slideDurationPerAnimation + '"><![CDATA[' + currentHtmlForSlide + ']]>';

                                let defaultWidth = 1920; // the canvas size is 800x450 and the export view is 1920x1080
                                let defaultHeight = 1080;
                                let positionScaleX = defaultWidth / this.CANVAS_WIDTH;
                                let positionScaleY = positionScaleX; // keep aspect ratio

                                let scaleValueX = endAnimation.width / startAnimation.width;
                                let scaleValueY = endAnimation.height / startAnimation.height;

                                let offset = this.ANIMATION_SCALE_OFFSET;
                                let shapeScaleX = startAnimation.width / (800 - 2 * offset);
                                let shapeScaleY = startAnimation.height / (450 - 2 * offset);
                                let shapeScale = 1;

                                if (shapeScaleX > 1 || shapeScaleY > 1)
                                    shapeScale = Math.max(shapeScaleX, shapeScaleY);
                                else {
                                    if (originalShape.type === shapeTypes.CHARACTER || originalShape.type === shapeTypes.IMAGE || originalShape.type === shapeTypes.RECTANGLE || originalShape.type === shapeTypes.ELLIPSE || originalShape.type === shapeTypes.HEART || originalShape.type === shapeTypes.STAR || originalShape.type === shapeTypes.TRIANGLE)
                                        shapeScale = Math.max(shapeScaleX, shapeScaleY);
                                }

                                let shapeXPosition = (400 - (startAnimation.width / shapeScale) / 2) * shapeScale;
                                let shapeYPosition = (225 - (startAnimation.height / shapeScale) / 2) * shapeScale;

                                //NOTE: - each animated shape is moved to the middle of canvas
                                //       - the start canvas position is transformed into an image and that image is used for animations
                                //       - if endWidth is double of startWidth, then the whole image is scaled to the right (the left-top will stay at 0-0)
                                let startLeftPos = (startAnimation.x - shapeXPosition) * positionScaleX;
                                let endLeftPos = (endAnimation.x - shapeXPosition * scaleValueX) * positionScaleX;

                                let startTopPos = (startAnimation.y - shapeYPosition) * positionScaleY;
                                let endTopPos = (endAnimation.y - shapeYPosition * scaleValueY) * positionScaleY;

                                data = data + '<filter startWidth="' + defaultWidth * shapeScale + '" endWidth="' + defaultWidth * shapeScale * scaleValueX + '" startHeight="' + defaultHeight * shapeScale + '" endHeight="' + defaultHeight * shapeScale * scaleValueY + '" startTop="' + startTopPos + '" endTop="' + endTopPos + '" startLeft="' + startLeftPos + '" endLeft="' + endLeftPos + '" type="kenBurns"/>';

                                if (startAnimation.opacity >= 0 && endAnimation.opacity >= 0 && startAnimation.opacity != endAnimation.opacity) {
                                    data = data + '<opacity>';

                                    data = data + '<entry time="0" value="' + startAnimation.opacity  + '"/>';
                                    data = data + '<entry time="' + slideDurationPerAnimation + '" value="' + endAnimation.opacity  + '"/>';

                                    data = data + '</opacity>';
                                }

                                data = data + '</html>';
                            }
                        } else {
                            data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + slideDuration + '"><![CDATA[' + htmlsForSlide[j] + ']]>';
                            data = data + '</html>';
                        }
                    } else {
                        data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + slideDuration + '"></html>';
                    }

                    currentTime = currentTime + slideDuration;
                }

                data = data + '</layer>';
            }
        }

        /*************************************************** layer used for video shapes  ************************************/
        /*** the number of layers should be the maximum video shapes on a slide ************************************/
        currentTime = 0;

        let maxVideoShapesPerSlide = 0;

        for (i=0; i<slides.length; i++) {
            slide = slides[i];

            if (slide.videoShapes && slide.videoShapes.length > 0) {
                if (slide.videoShapes.length > maxVideoShapesPerSlide)
                    maxVideoShapesPerSlide = slide.videoShapes.length;
            }
        }

        if (maxVideoShapesPerSlide > 0) { // there is at least one video shape on a slide
            data = data + '<!-- ********** Video shapes layers ******* -->';

            for (i = 0; i < maxVideoShapesPerSlide; i++) {
                currentTime = 0;
                data = data + '<layer>';

                for (j = 0; j < slides.length; j++) {
                    slide = slides[j];
                    duration = durationMap[j].duration;

                    if (slide.videoShapes.length >= (i + 1)) {
                        const videoShape = slide.videoShapes[i];
                        data = data + '<video begin="' + Math.floor(currentTime) + '" duration="' + duration + '" src="' + videoShape.src + '" width="' + Math.floor(videoShape.width) + '" height="' + Math.floor(videoShape.height) + '" left="' + Math.floor(videoShape.left) + '" top="' + Math.floor(videoShape.top) + '" volume="0.5" inPoint="0"/>';
                    } else
                        data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"/>';

                    if (durationMap[j].addTransition)
                        data = data + '<transition type="' + transitions[j] + '" duration="' + transitionsUtils.TRANSITION_DURATION + '"/>';

                    currentTime = currentTime + duration;
                }

                data = data + '</layer>';
            }
        }

        /****************************** layer used for main HTML: background and the rest of inactive elements (no videos, audios or animated shapes) *********************/
        data = data + '<!-- ********** HTML layer (the Main) ******* -->';
        data = data + '<layer>';
        currentTime = 0;

        for (i=0; i<slides.length; i++) {
            slide = slides[i];

            htmlsForSlide = slidesLayers[i].htmls;
            let backgroundHtmlForSlide = htmlsForSlide[0];

            duration = durationMap[i].duration;

            let isVideoBackground = false;

            if (slide.videoBackground && slide.videoBackground != '')
                isVideoBackground = true;

            if (useKenBurns && !isVideoBackground) {
                data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"><![CDATA[' + backgroundHtmlForSlide + ']]>';
                data = data + this.addKenBurns(duration);
                data = data + '</html>';
            } else
                data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"><![CDATA[' + backgroundHtmlForSlide + ']]></html>';

            if (durationMap[i].addTransition)
                data = data + '<transition type="' + transitions[i] + '" duration="' + transitionsUtils.TRANSITION_DURATION + '"/>';

            if (!isAudioEditor) {
                if (slide.sound && slide.sound != '')
                    hasSlideSounds = true;

                if (slide.soundEffect && slide.soundEffect != '')
                    hasSlideSoundEffect = true;
            }

            if (isVideoBackground)
                hasVideoBackground = true;

            currentTime = currentTime + duration;
        }

        data = data + '</layer>';

        /************************** layer used for videos used as backgrounds ********************************************/
        currentTime = 0;

        if (hasVideoBackground) {
            data = data + '<!-- ********** Video backgrounds ******* -->';
            data = data + '<layer>';

            for (i = 0; i < slides.length; i++) {
                slide = slides[i];
                duration = durationMap[i].duration;

                if (slide.videoBackground && slide.videoBackground != '') {
                    let videoSrc = this.getCorrectUrl(slide.videoBackground);

                    data = data + '<video begin="' + Math.floor(currentTime) + '" duration="' + duration + '" src="' + videoSrc + '" volume="' + slide.videoProperties.volume + '" inPoint="' + slide.videoProperties.inPoint + '"/>';
                } else
                    data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"/>';

                if (durationMap[i].addTransition)
                    data = data + '<transition type="' + transitions[i] + '" duration="' + transitionsUtils.TRANSITION_DURATION + '"/>';

                currentTime = currentTime + duration;
            }

            data = data + '</layer>';
        }

        /**********************************************************************/

        if (!isAudioEditor) {
            // layer used for Slide sounds
            currentTime = 0;

            if (hasSlideSounds) {
                data = data + '<layer>';

                for (i = 0; i < slides.length; i++) {
                    slide = slides[i];

                    if (slide.sound && slide.sound != '')
                        data = data + '<audio duration="' + Math.floor(slide.time * 1000) + '" src="' + this.getCorrectUrl(slide.sound) + '" begin="' + Math.floor(currentTime) + '" volume="' + slide.soundVolume + '"/>';

                    currentTime = currentTime + Math.floor(slide.time * 1000);
                }

                data = data + '</layer>';
            }

            // layer used for Slide sound effects
            currentTime = 0;

            if (hasSlideSoundEffect) {
                data = data + '<layer>';

                for (i = 0; i < slides.length; i++) {
                    slide = slides[i];

                    if (slide.soundEffect && slide.soundEffect != '')
                        data = data + '<audio duration="' + Math.floor(slide.time * 1000) + '" src="' + this.getCorrectUrl(slide.soundEffect) + '" begin="' + Math.floor(currentTime) + '" volume="' + slide.soundEffectVolume + '"/>';

                    currentTime = currentTime + Math.floor(slide.time * 1000);
                }

                data = data + '</layer>';
            }

            // story sound layer
            if (this.storySound) {
                var fadeOutDuration = 4000;
                var fadeOutEntries = 10;
                var startFadeOut = totalTime - fadeOutDuration;
                var entry = fadeOutDuration / fadeOutEntries;
                const audio = document.getElementById('storySound');
                var storySoundDuration = 0;

                if (audio)
                    storySoundDuration = Math.floor(audio.duration * 1000);

                data = data + '<layer>';

                if (storySoundDuration > 0 && storySoundDuration < totalTime) {
                    var repeats = Math.floor(totalTime / storySoundDuration);

                    for (i = 0; i < repeats; i++) {
                        data = data + '<audio duration="' + storySoundDuration + '" src="' + this.getCorrectUrl(this.storySound.href) + '"/>';
                    }

                    totalTime = totalTime - repeats * storySoundDuration;

                    if (totalTime <= fadeOutDuration) {
                        fadeOutDuration = totalTime;
                        startFadeOut = 0;
                    } else {
                        startFadeOut = totalTime - fadeOutDuration;
                    }

                    entry = fadeOutDuration / fadeOutEntries;
                }

                data = data + '<audio duration="' + Math.floor(totalTime) + '" src="' + this.getCorrectUrl(this.storySound.href) + '">';
                data = data + '<volume>';
                data = data + `<entry time="${0}" value="${this.storySound.volume}" />`;

                if (startFadeOut > 0)
                    data = data + `<entry time="${startFadeOut}" value="${this.storySound.volume}" />`;

                for (i = 0; i < fadeOutEntries; i++) {
                    var time = startFadeOut + (i + 1) * entry;
                    var remainingTime = totalTime - time;
                    var percent = remainingTime / fadeOutDuration;
                    var value = this.storySound.volume * percent;

                    data = data + `<entry time="${time}" value="${value}" />`;
                }

                data = data + '</volume>';
                data = data + '</audio>';
                data = data + '</layer>';
            }
        } else { // is audio editor functionality
            for (i = 0; i < this.timelines.length; i++) {
                data = data + this.createTimelineLayer(this.timelines[i]);
            }
        }

        data = data + '</layers></timeline>';

        console.log(data);

        return data;
    },
    createAudioXML() {
        var i;
        var data = '<timeline version="1"><layers>';

        for (i = 0; i < this.timelines.length; i++) {
            data = data + this.createTimelineLayer(this.timelines[i]);
        }

        data = data + '</layers></timeline>';

        console.log(data);

        return data;
    },
    createTimelineLayer(timeline) {
        if (timeline.audios.length < 1) // no audio on the current timeline
            return '';

        var data = '<layer>';
        var audios = timeline.audios;
        var audio;
        var timelineVolume = 1;
        var i;

        if (timeline.volume >= 0)
            timelineVolume = timeline.volume;

        for (i=0; i<audios.length; i++) {
            audio = audios[i];

            if (!audio.inPoint)
                audio.inPoint = 0;

            if (!audio.outPoint)
                audio.outPoint = 0;

            if (!audio.left)
                audio.left = 0;

            if (audio.inPoint > 0)
                data = data + '<audio duration="' + Math.floor(audio.duration * 1000) + '" src="' + this.getCorrectUrl(audio.href) + '" inPoint="' + Math.floor(audio.inPoint * 1000) + '" begin="' + Math.floor(audio.left * 1000) + '">';
            else
                data = data + '<audio duration="' + Math.floor(audio.duration * 1000) + '" src="' + this.getCorrectUrl(audio.href) + '" begin="' + Math.floor(audio.left * 1000) + '">';

            data = data + '<volume>';

            data = data + this.getVolumeEntries(audio, timelineVolume);

            data = data + '</volume>';
            data = data + '</audio>';
        }

        data = data + '</layer>';

        return data;
    },
    getCorrectVolume(volume) {
        return volume.toFixed(2);
    },
    getVolumeEntries(audio, timelineVolume) {
        var points = audio.points;
        var data = '';
        var j;
        var currentPoint;
        var pointsMap = [];
        var newPoints = [];

        if (points) {
            // check to see if there are duplicates related to time position
            for (j = 0; j < points.length; j++) {
                currentPoint = points[j];
                currentTime = Math.floor(currentPoint.time * 1000);

                if (!pointsMap[currentTime]) {
                    pointsMap[currentTime] = true;
                    newPoints.push(currentPoint);
                }
            }

            points = newPoints;
        }

        if (points == undefined || points.length < 2)
            points = [{time: 0, vol: 1}, {time: audio.duration, vol: 1}];

        if (points.length == 2 && points[0].vol == points[1].vol) { // there are only 2 points with the same volume
            data = data + `<entry time="${Math.floor(points[0].time * 1000)}" value="${this.getCorrectVolume(points[0].vol * timelineVolume)}"/>`;
            data = data + `<entry time="${Math.floor(points[1].time * 1000)}" value="${this.getCorrectVolume(points[1].vol * timelineVolume)}"/>`;

            return data;
        }

        var previousTime;
        var currentTime;
        var inPoint = 0;

        if (audio.inPoint > 0)
            inPoint = Math.floor(audio.inPoint * 1000);

        for (j=0; j<points.length; j++) {
            currentPoint = points[j];
            currentTime = Math.floor(currentPoint.time * 1000);

            if (previousTime >= 0 && previousTime == currentTime) {
                //do nothing
            } else {
                data = data + `<entry time="${currentTime - inPoint}" value="${this.getCorrectVolume(currentPoint.vol * timelineVolume)}"/>`;
                previousTime = currentTime;
            }
        }

        return data;
    },
    getFadeOutFactor(endTime, position) {
        return 1; // removed fade-out functionality

        var fadeDuration = playController.FADE_LIMIT;
        var remainingTime = endTime - position;

        if (remainingTime > fadeDuration)
            return 1;

        return remainingTime / fadeDuration;
    },
    checkSlides(slides) {
        var slidesMaxPosition = audioEditorUtils.getSlidesMaxPosition();
        var timelineMaxPosition = audioEditorUtils.getTimelinesMaxPosition();
        var duration = timelineMaxPosition - slidesMaxPosition;

        if (duration > 0) {
            var emptySlide = {};
            var background = {};

            background.fill = '#ffffff';
            background.fillOpacity = 1;
            background.moods = [];
            background.stroke = '#000000';
            background.strokeOpacity = 0;
            background.strokeWidth = 1;
            background.type = 'Background';
            background.uuid = '123';

            emptySlide.contentItemId = -1;
            emptySlide.initialized = true;
            emptySlide.sound = '';
            emptySlide.soundEffect = '';
            emptySlide.soundEffectVolume = 0.5;
            emptySlide.soundVolume = 0.5;
            emptySlide.time = duration;
            emptySlide.uuid = '123';
            emptySlide.content = [background];

            slides.push(emptySlide);
        }

        return slides;
    },
    createSlideElements() {
        const data = this.getProductionData();
        var slides = data.slides;
        var slide;
        var i;
        var slideData;
        var volume;
        var isAudioEditor = playController.isAudioEditorAvailable();

        if (isAudioEditor)
            slides = this.checkSlides(slides);

        if (!isAudioEditor && data.storySound) {
            var storySoundVolume = data.storySoundVolume;

            if (!storySoundVolume)
                storySoundVolume = 0.5;

            this.storySound = {href: data.storySound.href, volume: storySoundVolume};
        }

        for (i=0; i<slides.length; i++) {
            slide = slides[i];

            slideData = {};

            slideData.time = slide.time;
            slideData.svg = this.createSVG(slide.content);
            slideData.videoBackground = this.getBackgroundVideoFromSlide(slide);
            slideData.videoProperties = this.getVideoProperties(slide);
            slideData.fonts = this.getFontsFromSlide(slide.content);
            slideData.videoShapes = this.getVideoShapesFromSlide(slide.content);

            if (!isAudioEditor) {
                slideData.sound = slide.sound;
                slideData.soundEffect = slide.soundEffect;

                // set sound volume
                volume = slide.soundVolume;

                if (!volume)
                    volume = 0.5;

                slideData.soundVolume = volume;

                // set sound effect volume
                volume = slide.soundEffectVolume;

                if (!volume)
                    volume = 0.5;

                slideData.soundEffectVolume = volume;
            }

            this.slides.push(slideData);
        }

        if (isAudioEditor)
            this.timelines = data.audioEditor.timelines;
    },

    /*************************************************** Loading video stuff **********************************/
    wrongVideos: [],
    ensureIsOriginalVideo(url) {
        if (url.indexOf('proxy') > 0) {
            url = url.replace('proxy', 'original');
        }

        return url;
    },
    extractVideoId(link) {
        var id;

        if (!link)
            return id;

        var index = link.indexOf('file/ci/');
        var index2 = link.indexOf('/aaa');

        if (index > 0 && index2 > 0)
            id = link.substring(index + 8, index2);

        return id;
    },
    getHostName() {
        if (configuration.IS_PROD())
            return 'https://www.creaza.com';
        else
            return 'https://stage.creaza.com';
    },
    getCorrectUrl(url) {
        var securityCode = 'security_token_placeholder';
        var newUrl = '';

        if (url && url.indexOf('file/ci') != -1) {
            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1)
                newUrl = this.getHostName();

            newUrl = newUrl + url;

            if (url.indexOf('cacheBreaker') != -1)
                newUrl = newUrl + '&' + securityCode;
            else
                newUrl = newUrl + '?' + securityCode;
        } else {
            newUrl = url;
        }

        return newUrl;
    },
    getBackgroundVideoFromSlide(slide) {
        var background = slide.content[0];

        if (background.isVideo) {
            var link = background.xlinkHref;
            var id = this.extractVideoId(link);

            if (id && this.videoIds.indexOf(id) < 0)
                this.videoIds.push(id);

            return this.ensureIsOriginalVideo(link);
        } else
            return '';
    },
    getVideoProperties(slide) {
        var properties = {};
        var background = slide.content[0];

        properties.volume = 0.5;

        if (background.volume >= 0)
            properties.volume = background.volume;

        properties.inPoint = 0;

        if (background.inPoint)
            properties.inPoint = Math.floor(background.inPoint * 1000);

        return properties;
    },
    getCorrectVideoShapeUrl(link) {
        if (link && link.length > 0) {
            let id = this.extractVideoId(link);

            if (id && this.videoIds.indexOf(id) < 0)
                this.videoIds.push(id);

            return this.getCorrectUrl(this.ensureIsOriginalVideo(link));
        } else
            return '';
    },
    getVideoShapesFromSlide(shapes) {
        let shape;
        let videoShapes = [];
        const scale = 1920 / configuration.CANVAS_WIDTH; // 1920x1080 is the standard layer size while 800x450 is the Cartoonist canvas size

        for (let i=0; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.type == shapeTypes.VIDEO) {
                let videoElement = {};

                videoElement.src = this.getCorrectVideoShapeUrl(shape.xlinkHref);
                videoElement.width = shape.width * scale;
                videoElement.height = shape.height * scale;
                videoElement.left = shape.x * scale;
                videoElement.top = shape.y * scale;

                //TODO: add inPoint and volume like for "getVideoProperties" when will introduce videoEditor for video shapes

                videoShapes.push(videoElement);
            }
        }

        return videoShapes;
    },
    createVideoMap(data) { // get a pair for each video between proxy and original videos
        let array = data.mappings;
        let i;

        for (i=0; i<array.length; i++) {
            if (array[i].id)
                this.videoMap[array[i].id] = array[i].sourceFileId; // map[proxy] = original
        }

        // do a check to see if all the videos has pair (proxy-original) ... in case original is missing then use the proxy
        for (i=0; i<this.videoIds.length; i++) {
            let proxyId = parseInt(this.videoIds[i]);

            if (!this.videoMap[proxyId])
                this.videoMap[proxyId] = proxyId;
        }

        this.loadOriginalVideos();
    },
    loadOriginalVideos() {
        var key;
        var video;
        var index = 0;
        var videoLength = 0;

        this.wrongVideos = [];

        for (key in this.videoMap) {
            video = document.createElement('video');
            videoLength = videoLength + 1;

            video.addEventListener('durationchange', function() {
                index = index + 1;

                if (index == videoLength)
                    this.allVideosLoaded();
            }.bind(this));

            video.addEventListener('error', function(e) {
                var id  = this.extractVideoId(e.currentTarget.currentSrc);

                if (id && id.length > 0)
                    this.wrongVideos[id] = true;

                index = index + 1;

                if (index == videoLength)
                    this.allVideosLoaded();
            }.bind(this));

            video.src = this.getHostName() + '/file/ci/' + this.videoMap[key] + '/aaa' + videoUtils.cacheBreaker;
            video.load();
        }
    },
    allVideosLoaded() {
        this.useOriginalLinksForVideos();
    },
    useOriginalLinksForVideos() {
        let i;
        let videoLink;
        let id;
        let originalId;
        let videoShapes;

        for (i=0; i<this.slides.length; i++) {
            videoLink = this.slides[i].videoBackground;

            if (videoLink && videoLink.length > 0) {
                id  = this.extractVideoId(videoLink);

                if (id && this.videoMap[id]) {
                    originalId = this.videoMap[id];

                    if (!this.wrongVideos[originalId])
                        this.slides[i].videoBackground = videoLink.replace(id, originalId);
                } else {
                    if (videoLink.indexOf('proxy') > 0) {
                        this.slides[i].videoBackground = videoLink.replace('proxy', 'original');
                    }
                }
            }

            videoShapes = this.slides[i].videoShapes;

            for (let j=0; j<videoShapes.length; j++) {
                videoLink = videoShapes[j].src;

                if (videoLink && videoLink.length > 0) {
                    id  = this.extractVideoId(videoLink);

                    if (id && this.videoMap[id]) {
                        originalId = this.videoMap[id];

                        if (!this.wrongVideos[originalId])
                            videoShapes[j].src = videoLink.replace(id, originalId);
                    } else {
                        if (videoLink.indexOf('proxy') > 0) {
                            videoShapes[j].src = videoLink.replace('proxy', 'original');
                        }
                    }
                }
            }
        }

        this.export();
    },
    getProductionData() {
        const state = storeManager.getState();
        const production = state.production;
        const title  = appParameters.title;
        var data = {};

        data.storySound = production.storySound;
        data.storySoundVolume = production.storySoundVolume;
        data.title = title;
        data.slides = production.slides;
        data.audioEditor = state.audioEditor;

        return data;
    },
    getTimelines() {
        const state = storeManager.getState();
        this.timelines = state.audioEditor.timelines;
    },
    getFontsMap() {
        var map = [];

        map['AlfaSlabOne'] = 'AlfaSlabOneRegular';
        map['Anton'] = 'AntonRegular';
        map['ArchitectsDaughter'] = 'ArchitectsDaughter';
        map['Bangers'] = 'BangersRegular';
        map['BungeeShade'] = 'BungeeShadeRegular';
        map['Cabin'] = 'CabinRegular';
        map['CabinMedium'] = 'CabinMedium';
        map['CaveatBrush'] = 'CaveatBrushRegular';
        map['Creepster'] = 'CreepsterRegular';
        map['Pangolin'] = 'PangolinRegular';
        map['Peralta'] = 'PeraltaRegular';
        map['PermanentMarker'] = 'PermanentMarker';
        map['Raleway'] = 'RalewayRegular';
        map['RalewayBlack'] = 'RalewayBlack';
        map['RalewayThin'] = 'RalewayThin';
        map['Shrikhand'] = 'ShrikhandRegular';
        map['Sniglet'] = 'SnigletRegular';
        map['SnigletExtra'] = 'SnigletExtraBold';
        map['Sriracha'] = 'SrirachaRegular';

        return map;
    },
    getHtmlForSlide(slide) {
        var fontsMap = this.getFontsMap();
        var data = '<html>';
        var i;
        var htmls = [];
        var fontUrl = 'https://creaza-cartoonist-svg.s3.amazonaws.com/cartoonist/fonts/';

        data = data + '<head><meta charset="UTF-8">';

        if (slide.fonts.length > 0) {
            for (i=0; i<slide.fonts.length; i++) {
                if (slide.fonts[i] == 'Arial') {
                    data = data + '<style> @font-face { font-family: Cabin;src: url(' + fontUrl + 'CabinRegular.ttf);}</style>';
                }
                else
                    data = data + '<style> @font-face { font-family: ' + slide.fonts[i] + ';src: url(' + fontUrl + fontsMap[slide.fonts[i]] + '.ttf);}</style>';
            }
        }

        data = data + '</head>';

        var svgs = slide.svg.svgs;

        for (i=0; i<svgs.length; i++) {
            htmls.push(data + '<body><div>' + svgs[i] + '</div></body></html>');
        }

        return {htmls: htmls, animations: slide.svg.animations, animatedShapes: slide.svg.animatedShapes};
    },
    getFontsFromSlide(shapes, currentFonts = undefined) {
        var shape;
        var i;
        var fonts;
        var fontsMap = this.getFontsMap();

        if (currentFonts)
            fonts = currentFonts;
        else
            fonts = [];

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.type == shapeTypes.TEXTBOX || shape.type == shapeTypes.TEXTBOXSIMPLE || shape.type == shapeTypes.SPEAK_BUBBLE || shape.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shape.type == shapeTypes.SCREAM_BUBBLE || shape.type == shapeTypes.THOUGHT_BUBBLE) {
                if (shape.isRichText) {
                    var htmlText = textSizeUtils.getHtmlText(shape);

                    for (var key in fontsMap) {
                        if (htmlText.indexOf(key) != -1) {
                            if (fonts.indexOf(key) == -1)
                                fonts.push(key);
                        }
                    }
                } else {
                    if (fonts.indexOf(shape.fontFamily) == -1)
                        fonts.push(shape.fontFamily);
                }
            }

            if (shape.type == shapeTypes.GROUP)
                fonts = this.getFontsFromSlide(shape.shapes, fonts);
        }

        return fonts;
    },


    /******************************* Used for point to point animation *************************************/

    getShapeAsStartAnimation(shape, startAnimation) {
        if (startAnimation.x)
            shape.x = startAnimation.x;

        if (startAnimation.y)
            shape.y = startAnimation.y;

        if (startAnimation.width)
            shape.width = startAnimation.width;

        if (startAnimation.height)
            shape.height = startAnimation.height;

        if (startAnimation.fontSize)
            shape.fontSize = startAnimation.fontSize;

        if (startAnimation.opacity)
            shape.opacity = startAnimation.opacity;

        if (startAnimation.rotation)
            shape.rotation = startAnimation.rotation;

        if (startAnimation.x1)
            shape.x1 = startAnimation.x1;

        if (startAnimation.y1)
            shape.y1 = startAnimation.y1;

        if (startAnimation.x2)
            shape.x2 = startAnimation.x2;

        if (startAnimation.y2)
            shape.y2 = startAnimation.y2;

        if (startAnimation.cx)
            shape.cx = startAnimation.cx;

        if (startAnimation.cy)
            shape.cy = startAnimation.cy;

        if (startAnimation.cx1)
            shape.cx1 = startAnimation.cx1;

        if (startAnimation.cy1)
            shape.cy1 = startAnimation.cy1;

        if (startAnimation.cx2)
            shape.cx2 = startAnimation.cx2;

        if (startAnimation.cy2)
            shape.cy2 = startAnimation.cy2;

        if (startAnimation.cx3)
            shape.cx3 = startAnimation.cx3;

        if (startAnimation.cy3)
            shape.cy3 = startAnimation.cy3;

        if (startAnimation.cx4)
            shape.cx4 = startAnimation.cx4;

        if (startAnimation.cy4)
            shape.cy4 = startAnimation.cy4;

        if (startAnimation.cx5)
            shape.cx5 = startAnimation.cx5;

        if (startAnimation.cy5)
            shape.cy5 = startAnimation.cy5;

        return shape;
    },
    getHtmlFromAnimation(originalShape, startAnimation) {
        let newShape = Object.assign({}, originalShape);

        newShape = this.getShapeAsStartAnimation(newShape, startAnimation);

        return this.getHtmlFromSingleShape(newShape);
    },
    getHtmlFromSingleShape(shape) {
        let htmlData = '';

        switch(shape.type) {
            case shapeTypes.CHARACTER: {
                htmlData = htmlData + this.visitCharacter(shape);
                break;
            }
            case shapeTypes.IMAGE: {
                htmlData = htmlData + this.visitImage(shape);
                break;
            }
            case shapeTypes.RECTANGLE: {
                htmlData = htmlData + this.visitRectangle(shape);
                break;
            }
            case shapeTypes.TRIANGLE: {
                htmlData = htmlData + this.visitTriangle(shape);
                break;
            }
            case shapeTypes.STAR: {
                htmlData = htmlData + this.visitStar(shape);
                break;
            }
            case shapeTypes.HEART: {
                htmlData = htmlData + this.visitHeart(shape);
                break;
            }
            case shapeTypes.ELLIPSE: {
                htmlData = htmlData + this.visitEllipse(shape);
                break;
            }
            case shapeTypes.LINE: {
                htmlData = htmlData + this.visitLine(shape);
                break;
            }
            case shapeTypes.CURVE: {
                htmlData = htmlData + this.visitCurve(shape);
                break;
            }
            case shapeTypes.FREEHAND: {
                htmlData = htmlData + this.visitFreehand(shape);
                break;
            }
            case shapeTypes.TEXTBOX: {
                htmlData = htmlData + this.visitTextbox(shape);
                break;
            }
            case shapeTypes.TEXTBOXSIMPLE: {
                htmlData = htmlData + this.visitTextboxSimple(shape);
                break;
            }
            case shapeTypes.SPEAK_BUBBLE: {
                htmlData = htmlData + this.visitSpeakBubble(shape);
                break;
            }
            case shapeTypes.COMPLEX_SPEAK_BUBBLE: {
                htmlData = htmlData + this.visitComplexSpeakBubble(shape);
                break;
            }
            case shapeTypes.THOUGHT_BUBBLE: {
                htmlData = htmlData + this.visitThoughtBubble(shape);
                break;
            }
            case shapeTypes.SCREAM_BUBBLE: {
                htmlData = htmlData + this.visitScreamBubble(shape);
                break;
            }
            case shapeTypes.VIDEO: {
                htmlData = htmlData + this.visitVideo(shape);
                break;
            }
            case shapeTypes.GROUP: {
                htmlData = htmlData + this.visitGroup(shape);
                break;
            }
        }

        let viewBox = '0 0 ' + this.CANVAS_WIDTH + ' ' + this.CANVAS_HEIGHT;
        let devs = '';

        if (htmlData.indexOf('url(#') != -1)
            devs = `<defs><filter id="2" width="150%" height="150%"><feOffset result="offOut" in="SourceAlpha" dx="4" dy="4"/><feGaussianBlur result="blurOut" in="offOut" stdDeviation="4"/><feBlend in="SourceGraphic" in2="blurOut" mode="normal"/></filter><filter id="5" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%"><feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0"/></filter></defs>`;

        let svg = `<svg style="position:fixed; top:0; left:0; height:100%; width:100%" width="${this.CANVAS_WIDTH}" height="${this.CANVAS_HEIGHT}" viewBox="${viewBox}">${devs}${htmlData}</svg>`;

        let data = '<html>';
        let fontsMap = this.getFontsMap();
        let i;
        let fontUrl = 'https://creaza-cartoonist-svg.s3.amazonaws.com/cartoonist/fonts/';
        let fonts = this.getFontsFromSlide([shape]);

        data = data + '<head><meta charset="UTF-8">';

        if (fonts.length > 0) {
            for (i=0; i<fonts.length; i++) {
                if (fonts[i] == 'Arial') {
                    data = data + '<style> @font-face { font-family: Cabin;src: url(' + fontUrl + 'CabinRegular.ttf);}</style>';
                }
                else
                    data = data + '<style> @font-face { font-family: ' + fonts[i] + ';src: url(' + fontUrl + fontsMap[fonts[i]] + '.ttf);}</style>';
            }
        }

        data = data + '</head>';
        data = data + '<body><div>' + svg + '</div></body></html>';

        return data;
    },

    /********************************************************************/

    getHtmlFromShapes(shapes, isGroup = false) {
        var shape;
        var i;
        var htmlData = '';
        var layers = [];
        var animations = [];
        let animatedShapes = [];

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            if (isGroup) // for the shapes inside of a group, the animations should not be considered
                shape.animation = undefined;

            switch(shape.type) {
                case shapeTypes.BACKGROUND:
                {
                    htmlData = htmlData + this.visitBackground(shape);
                    break;
                }
                case shapeTypes.CHARACTER:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitCharacter(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitCharacter(shape);
                    break;
                }
                case shapeTypes.IMAGE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitImage(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitImage(shape);
                    break;
                }
                case shapeTypes.RECTANGLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitRectangle(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitRectangle(shape);
                    break;
                }
                case shapeTypes.TRIANGLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitTriangle(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitTriangle(shape);
                    break;
                }
                case shapeTypes.STAR:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitStar(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitStar(shape);
                    break;
                }
                case shapeTypes.HEART:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitHeart(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitHeart(shape);
                    break;
                }
                case shapeTypes.ELLIPSE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitEllipse(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitEllipse(shape);
                    break;
                }
                case shapeTypes.LINE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitLine(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitLine(shape);
                    break;
                }
                case shapeTypes.CURVE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitCurve(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitCurve(shape);
                    break;
                }
                case shapeTypes.FREEHAND:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitFreehand(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitFreehand(shape);
                    break;
                }
                case shapeTypes.TEXTBOX:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitTextbox(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitTextbox(shape);
                    break;
                }
                case shapeTypes.TEXTBOXSIMPLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitTextboxSimple(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitTextboxSimple(shape);
                    break;
                }
                case shapeTypes.SPEAK_BUBBLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitSpeakBubble(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitSpeakBubble(shape);
                    break;
                }
                case shapeTypes.COMPLEX_SPEAK_BUBBLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitComplexSpeakBubble(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitComplexSpeakBubble(shape);
                    break;
                }
                case shapeTypes.THOUGHT_BUBBLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitThoughtBubble(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitThoughtBubble(shape);
                    break;
                }
                case shapeTypes.SCREAM_BUBBLE:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitScreamBubble(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitScreamBubble(shape);
                    break;
                }
                case shapeTypes.VIDEO:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitVideo(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitVideo(shape);
                    break;
                }
                case shapeTypes.GROUP:
                {
                    if (shape.animation) {
                        if (htmlData.length > 0) {
                            layers.push(htmlData);
                            animations.push(0);
                            animatedShapes.push(0);
                        }

                        htmlData = '' + this.visitGroup(shape);

                        layers.push(htmlData);
                        animations.push(shape.animation);
                        animatedShapes.push(shape);
                        htmlData = '';
                    } else
                        htmlData = htmlData + this.visitGroup(shape);
                    break;
                }
            }
        }

        if (htmlData.length > 0) {
            layers.push(htmlData);
            animations.push(0);
            animatedShapes.push(0);
        }

        return {layers: layers, animations: animations, animatedShapes: animatedShapes};
    },
    createSVG(shapes) {
        var htmlData = this.getHtmlFromShapes(shapes);
        var layers = htmlData.layers;
        var svgs = [];
        var i;
        var viewBox = '0 0 ' + this.CANVAS_WIDTH + ' ' + this.CANVAS_HEIGHT;
        var devs = '';

        for (i=0; i<layers.length; i++) {
            if (layers[i] && layers[i].indexOf('url(#') != -1) {
                devs = `<defs><filter id="2" width="150%" height="150%"><feOffset result="offOut" in="SourceAlpha" dx="4" dy="4"/><feGaussianBlur result="blurOut" in="offOut" stdDeviation="4"/><feBlend in="SourceGraphic" in2="blurOut" mode="normal"/></filter><filter id="5" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%"><feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0"/></filter></defs>`;
                break;
            }
        }

        for (i=0; i<layers.length; i++) {
            svgs.push(`<svg style="position:fixed; top:0; left:0; height:100%; width:100%" width="${this.CANVAS_WIDTH}" height="${this.CANVAS_HEIGHT}" viewBox="${viewBox}">${devs}${layers[i]}</svg>`);
        }

        return {svgs: svgs, animations: htmlData.animations, animatedShapes: htmlData.animatedShapes};
    },
    getImageBoundingBox(shapeModel) {
        var imageBoundingBox = {x: 0, y: 0, width: this.CANVAS_WIDTH, height: this.CANVAS_HEIGHT};

        if ((shapeModel.orgWidth > 0 && shapeModel.orgWidth != this.CANVAS_WIDTH) || (shapeModel.orgHeight> 0 && shapeModel.orgHeight != this.CANVAS_HEIGHT)) {
            var scaleX = this.CANVAS_WIDTH / shapeModel.orgWidth;
            var scaleY =  this.CANVAS_HEIGHT / shapeModel.orgHeight;

            if (scaleX < scaleY) {
                imageBoundingBox.y = this.CANVAS_HEIGHT / 2 - scaleX * shapeModel.orgHeight / 2;
                imageBoundingBox.height = scaleX * shapeModel.orgHeight;
            } else {
                imageBoundingBox.x = this.CANVAS_WIDTH / 2 - scaleY * shapeModel.orgWidth / 2;
                imageBoundingBox.width = scaleY * shapeModel.orgWidth;
            }
        }

        return imageBoundingBox;
    },
    getImagePosition(shapeModel) {
        var hotspot = shapeModel.hotSpot;
        var boundingBox = this.getImageBoundingBox(shapeModel);
        var position = {};

        if (hotspot == undefined || hotspot == '') {
            position.x = boundingBox.x;
            position.y = boundingBox.y;
            position.width = boundingBox.width;
            position.height = boundingBox.height;
        } else {
            var scale;

            if ((shapeModel.orgWidth > 0 && shapeModel.orgWidth != this.CANVAS_WIDTH) || (shapeModel.orgHeight> 0 && shapeModel.orgHeight != this.CANVAS_HEIGHT)) {
                scale = this.CANVAS_WIDTH / hotspot.width;

                position.width = boundingBox.width * scale;
                position.height = boundingBox.height  * scale;

                position.x = - hotspot.x * scale + boundingBox.x * scale;
                position.y = - hotspot.y * scale + boundingBox.y * scale;

            } else {
                scale = this.CANVAS_WIDTH / hotspot.width;

                position.width = this.CANVAS_WIDTH * scale;
                position.height = position.width * 9 / 16;

                position.x = - hotspot.x * scale;
                position.y = - hotspot.y * scale;
            }
        }

        position.x = position.x.toFixed(2);
        position.y = position.y.toFixed(2);
        position.width = position.width.toFixed(2);
        position.height = position.height.toFixed(2);

        return position;
    },
    basicShape(shapeModel) {
        let rotation = shapeModel.rotation;
        let data;

        if (rotation == undefined)
            rotation = 0;

        let rotateTransform = `rotate(${rotation} ${shapeModel.width/2} ${shapeModel.height/2})`;
        let flipTransform = '';

        if (shapeModel.horizontalFlip && shapeModel.verticalFlip) {
            let flipTranslateX = shapeModel.horizontalFlip < 0 ? -shapeModel.width : 0;
            let flipTranslateY = shapeModel.verticalFlip < 0 ? -shapeModel.height : 0;
            flipTransform = `scale(${shapeModel.horizontalFlip} ${shapeModel.verticalFlip}) translate(${flipTranslateX} ${flipTranslateY})`;
        }

        data = `<g transform="translate(${shapeModel.x} ${shapeModel.y})">`;

        if (shapeModel.animation) {
            let offset = this.ANIMATION_SCALE_OFFSET;
            let scaleX = (800 - 2 * offset) / shapeModel.width;
            let scaleY = (450 - 2 * offset) / shapeModel.height;
            let scale = 1;

            // for the animation, the shape is moved in the middle of canvas but with a scale to fit maximum possible inside of canvas area [800-10 (scale offset) / 450-10 (scale offset)]
            // during the animation we apply the opposite scale to fit into the startWidth/startHeight position
            if (scaleX < 1 || scaleY < 1)
                scale = Math.min(scaleX, scaleY);
            else {
                if (shapeModel.type === shapeTypes.CHARACTER || shapeModel.type === shapeTypes.IMAGE || shapeModel.type === shapeTypes.RECTANGLE || shapeModel.type === shapeTypes.ELLIPSE || shapeModel.type === shapeTypes.HEART || shapeModel.type === shapeTypes.STAR || shapeModel.type === shapeTypes.TRIANGLE)
                    scale = Math.min(scaleX, scaleY);
            }

            if (this.testLocalAnimation) {
                data = `<g id="background" x="0.00" y="0.00" width="800" height="450"><rect x="0.00" y="0.00" width="800" height="450" fill="#ffc600" fill-opacity="1"></rect><image x="0.00" y="0.00" width="800.00" height="450.00" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="undefined" preserveAspectRatio="none" opacity="1"></image><rect x="0" y="0" width="800" height="450" fill="none" stroke="#000000" stroke-width="2" stroke-opacity="0"></rect></g>`;

                data = data + `<g transform="translate(${400 - shapeModel.width * scale / 2} ${225 - shapeModel.height * scale / 2}) scale(${scale} ${scale})">`;
            } else
                data = `<g transform="translate(${400 - shapeModel.width * scale / 2} ${225 - shapeModel.height * scale / 2}) scale(${scale} ${scale})">`;
        }

        data = data + `<g transform="${rotateTransform}">`;
        data = data + `<g transform="${flipTransform}">`;

        return data;
    },
    visitBackground(shapeModel) {
        const canvasWidth = this.CANVAS_WIDTH;
        const canvasHeight = this.CANVAS_HEIGHT;
        const position = this.getImagePosition(shapeModel);
        var fillValue = shapeModel.fill;

        if (shapeModel.isVideo)
            fillValue = 'none';

        var data = `<g id="background" x="0.00" y="0.00" width="${canvasWidth}" height="${canvasHeight}"><rect x="0.00" y="0.00" width="${canvasWidth}" height="${canvasHeight}" fill="${fillValue}" fill-opacity="${shapeModel.fillOpacity}"></rect><image x="${position.x}" y="${position.y}" width="${position.width}" height="${position.height}" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${this.getCorrectUrl(shapeModel.xlinkHref)}" preserveAspectRatio="none" opacity="${shapeModel.opacity}"></image><rect x="0" y="0" width="${canvasWidth}" height="${canvasHeight}" fill="none" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth * 2}" stroke-opacity="${shapeModel.strokeOpacity}"></rect></g>`;

        return data;
    },
    visitCharacter(shapeModel) {
        var clipPathObject;
        var realWidth = shapeModel.width;
        var realHeight = shapeModel.height;
        var newShapeModel = shapeModel;
        var x1 = 0;
        var y1 = 0;
        var clipId = 'hotSpot_' + shapeModel.uuid;
        var clipPath = 'url(#' + clipId + ')';

        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);

            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;

            clipPathObject = `<clipPath id="${clipId}"> <rect x="${x1}" y="${y1}" width="${x2 - x1}" height="${y2 - y1}"></rect></clipPath>`;
        }

        var filterName;
        var filter;
        var filterUrl;

        if (newShapeModel.backgroundVisible == false || newShapeModel.fillOpacity == 0) {
            // the filter shouldn't be visible
        } else {
            filterName = 'f_' + newShapeModel.uuid;
            filterUrl = 'url(#' + filterName + ')';

            filter = `<filter id="${filterName}"><feColorMatrix type='matrix' values="${colorUtils.hexToMatrix(newShapeModel.fill)}"/></filter>`;
        }

        var data = this.basicShape(newShapeModel);

        var opacityValue = newShapeModel.opacity;

        if (newShapeModel.animation && newShapeModel.animation.start_opacity >=0 && newShapeModel.animation.end_opacity >=0 && newShapeModel.animation.start_opacity != newShapeModel.animation.end_opacity)
            opacityValue = 1;

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        if (filter) {
            data = data + filter;
            data = data + `<g filter="${filterUrl}">`;
        }

        if (clipPathObject) {
            data = data + clipPathObject;
            data = data + `<g transform="translate(${-x1} ${-y1})">`;
            data = data + `<image x="${0}" y="${0}" width="${realWidth}" height="${realHeight}" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${this.getCorrectUrl(newShapeModel.xlinkHref)}" filter="${newShapeModel.filter}" preserveAspectRatio='none' clip-path="${clipPath}"/>`;
            data = data + `</g>`;

        } else
            data = data + `<image x="${0}" y="${0}" width="${newShapeModel.width}" height="${newShapeModel.height}" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${this.getCorrectUrl(newShapeModel.xlinkHref)}" filter="${newShapeModel.filter}" preserveAspectRatio='none' />`;

        data = data + `<rect x="${0}" y="${0}" width="${newShapeModel.width}" height="${newShapeModel.height}" fill="none" stroke="${newShapeModel.stroke}" stroke-width="${newShapeModel.strokeWidth}" stroke-opacity="${newShapeModel.strokeOpacity}" />`;

        data = data + '</g></g></g></g>';

        if (filter)
            data = data + '</g>';

        return data;
    },
    visitImage(shapeModel) {
        return this.visitCharacter(shapeModel);
    },
    visitRectangle(shapeModel) {
        var data = this.basicShape(shapeModel);
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        data = data + `<rect x="${0}" y="${0}" width="${shapeModel.width}" height="${shapeModel.height}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" opacity="${opacityValue}" />`;
        data = data + '</g></g></g>';

        return data;
    },
    visitTriangle(shapeModel) {
        var data = this.basicShape(shapeModel);
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        const path = `M${shapeModel.width/2} 0 L${shapeModel.width} ${shapeModel.height} L0 ${shapeModel.height} Z`;

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;
        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${opacityValue}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g></g></g></g>';

        return data;
    },
    visitStar(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        const points = drawingUtils.calculateStarPoints(shapeModel);
        var path = 'M' + points[0].x + ' ' + points[0].y + ' ';

        var i;
        for (i=1; i<points.length; i++) {
            path = path + 'L' + points[i].x + ' ' + points[i].y + ' ';
        }

        path = path + ' Z';

        var data = this.basicShape(shapeModel);
        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${opacityValue}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g></g></g></g>';

        return data;
    },
    getHeartPath(shapeModel) {
        const separator = ',';
        const bottomXOffset = shapeModel.width / 20;
        const bottomYOffset = shapeModel.height / 20;

        var path = 'M' + (shapeModel.width/2 + bottomXOffset) + separator + (shapeModel.height - bottomYOffset);

        path = path + 'Q' + shapeModel.width/2 + separator + shapeModel.height + separator + (shapeModel.width/2 - bottomXOffset) + separator + (shapeModel.height - bottomYOffset);

        const horizontalOffset = shapeModel.width / 10;
        const verticalOffset = shapeModel.height / 2;

        path = path + 'L' + horizontalOffset + separator + verticalOffset;

        const rx = shapeModel.width / 6;
        const ry = shapeModel.height / 6;
        const xAxisRotation = 1;
        const largeArcFlag = 0;
        const sweepFlag = 1;
        var endX = shapeModel.width / 2;
        var endY = shapeModel.height / 8;

        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;

        endX = shapeModel.width - horizontalOffset;
        endY = verticalOffset;

        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;

        path = path + 'Z';

        return path;
    },
    visitHeart(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        const path = this.getHeartPath(shapeModel);

        var data = this.basicShape(shapeModel);
        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${opacityValue}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g></g></g></g>';

        return data;
    },
    visitEllipse(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var data = this.basicShape(shapeModel);

        data = data + `<ellipse rx="${shapeModel.width / 2}" ry="${shapeModel.height / 2}" cx="${shapeModel.width / 2}" cy="${shapeModel.height / 2}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" opacity="${opacityValue}" />`;
        data = data + '</g></g></g>';

        return data;
    },
    visitLine(shapeModel) {
        let x = Math.min(shapeModel.x1, shapeModel.x2);
        let y = Math.min(shapeModel.y1, shapeModel.y2);

        var data = `<g transform="translate(${x} ${y})">`;

        data = data + '<g>';
        data = data + `<rect x="${0}" y="${0}" width="${Math.abs(shapeModel.x1 - shapeModel.x2)}" height="${Math.abs(shapeModel.y1 - shapeModel.y2)}" fill="${'#000000'}" opacity="${0}" />`;
        data = data + `<line x1="${shapeModel.x1 - x}" y1="${shapeModel.y1 - y}" x2="${shapeModel.x2 - x}" y2="${shapeModel.y2 - y}" filter="${shapeModel.filter}" opacity="${shapeModel.opacity}" fill='none' stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g></g>';

        return data;
    },
    createCurvePath (shapeModel) {
        const x = Math.min(shapeModel.x1, shapeModel.x2);
        const y = Math.min(shapeModel.y1, shapeModel.y2);
        const path = `M${shapeModel.x1 - x},${shapeModel.y1 - y}Q${shapeModel.cx - x},${shapeModel.cy - y},${shapeModel.x2 - x},${shapeModel.y2 - y}`;

        return path;
    },
    visitCurve(shapeModel) {
        const path = this.createCurvePath(shapeModel);

        const x = Math.min (shapeModel.x1, shapeModel.x2);
        const y = Math.min (shapeModel.y1, shapeModel.y2);

        var data = `<g transform="translate(${x} ${y})">`;
        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${shapeModel.opacity}" fill='#ffffff' fill-opacity='0' stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g>';

        return data;
    },
    createFreehandPath(shapeModel) {
        const pathPoints = shapeModel.pathPoints;
        const length = pathPoints.length;
        let i;
        let path = 'M' + pathPoints[0].x + ',' + pathPoints[0].y;

        for (i=0; i<length; i++) {
            path = path + 'L' + pathPoints[i].x + ',' + pathPoints[i].y;
        }

        return path;
    },
    visitFreehand(shapeModel) {
        const path = this.createFreehandPath(shapeModel);
        var data = this.basicShape(shapeModel);

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        data = data + '<g>';

        data = data + `<rect x="${0}" y="${0}" width="${shapeModel.width}" height="${shapeModel.height}" fill="${'#000000'}" opacity="${0}" />`;
        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${opacityValue}" fill='none' stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + '</g></g></g></g>';

        return data;
    },
    getTextStyle(shapeModel) {
        if (shapeModel.isRichText)
            return this.getTextStyleNew(shapeModel);
        else
            return this.getTextStyleOld(shapeModel);
    },
    getTextStyleNew(shapeModel) {
        const PADDING = properties.TEXT_PADDING;
        const INNER_PADDING = properties.TEXT_INNER_PADDING;
        const textProperties = textSizeUtils.textProperties(shapeModel);
        const EXTRA_PADDING = textProperties.extraPadding;
        const offset = 0;
        let data = '';
        let textAreaWidth = shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING + offset;
        let textAreaHeight = shapeModel.height - 2 * PADDING - 2 * INNER_PADDING;
        let paddingLeft;

        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
            let maxWidth = textAreaWidth * 0.7;
            let imageWidth = textAreaHeight * shapeModel.aspectRatio;

            if (imageWidth > maxWidth)
                imageWidth = maxWidth;

            paddingLeft = 2 * INNER_PADDING + imageWidth;
            textAreaWidth = textAreaWidth - INNER_PADDING - imageWidth;
        }

        data = data + 'width:' + textAreaWidth + 'px; ';
        data = data + 'height:' + textAreaHeight + 'px; ';
        data = data + 'resize: none; overflow: hidden; ';
        data = data + 'padding: ' + INNER_PADDING + 'px; ';
        data = data + 'border: none; outline: none; background: transparent; ';
        data = data + 'word-spacing: ' + textProperties.wordSpacing + 'px; ';
        data = data + 'letter-spacing: ' + textProperties.letterSpacing + 'px; ';
        data = data + 'overflow-wrap: break-word; ';

        if (shapeModel.lineHeight > 0)
            data = data + 'line-height: ' + shapeModel.lineHeight + '; ';
        else {
            if (textProperties.lineHeight != -1)
                data = data + 'line-height: ' + textProperties.lineHeight + '; ';
        }

        if (paddingLeft > 0)
            data = data + 'padding-left: ' + paddingLeft + 'px; ';

        return data;
    },
    getImageNode(shapeModel) {
        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
            const textProperties = textSizeUtils.textProperties(shapeModel);
            const EXTRA_PADDING = textProperties.extraPadding;
            let textAreaWidth = shapeModel.width - 2 * properties.TEXT_INNER_PADDING + EXTRA_PADDING;
            let textAreaHeight = shapeModel.height - 2 * properties.TEXT_INNER_PADDING;
            let maxWidth = textAreaWidth * 0.7;
            let imageWidth = textAreaHeight * shapeModel.aspectRatio;

            if (imageWidth > maxWidth)
                imageWidth = maxWidth;

            return `<image x="${properties.TEXT_INNER_PADDING}" y="${properties.TEXT_INNER_PADDING}" height="${textAreaHeight}" width="${imageWidth}" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${this.getCorrectUrl(shapeModel.imageNode)}" preserveAspectRatio="none" />`;
        } else
            return '';
    },
    getTextStyleOld(shapeModel) {
        const PADDING = properties.TEXT_PADDING;
        const INNER_PADDING = properties.TEXT_INNER_PADDING;
        const bold = shapeModel.fontBold ? 'bold' : 'normal';
        const italic = shapeModel.fontItalic ? 'italic' : 'normal';
        const textProperties = textSizeUtils.textProperties(shapeModel);
        const EXTRA_PADDING = textProperties.extraPadding;
        const offset = 0;

        var data = '';

        data = data + 'width:' + (shapeModel.width - 2 * PADDING + EXTRA_PADDING + offset) + 'px; ';
        data = data + 'height:' + (shapeModel.height - 2 * PADDING) + 'px; ';
        data = data + 'resize: none; overflow: hidden; ';
        data = data + 'padding: ' + INNER_PADDING + 'px; ';
        data = data + 'border: none; outline: none; background: transparent; ';
        data = data + 'font-family: ' + shapeModel.fontFamily + '; ';
        data = data + 'font-size: ' + shapeModel.fontSize + 'px; ';
        data = data + 'font-style: ' + italic + '; ';
        data = data + 'font-weight: ' + bold + '; ';
        data = data + 'text-align: ' + shapeModel.fontAlign + '; ';
        data = data + 'word-spacing: ' + textProperties.wordSpacing + 'px; ';
        data = data + 'letter-spacing: ' + textProperties.letterSpacing + 'px; ';
        data = data + 'color: ' + shapeModel.fontColor + '; ';

        if (textProperties.lineHeight != -1)
            data = data + 'line-height: ' + textProperties.lineHeight + '; ';

        if (shapeModel.fontUnderline)
            data = data + 'text-decoration: underline; ';

        return data;
    },
    encodeText(text) {
        return text.replace(/[\x0b-\x0d]/g, '-'); // replace all the non printable characters (from 11 to 13 ascii code) with the - character
    },
    visitTextbox(shapeModel) {
        var textStyle = this.getTextStyle(shapeModel);
        var backgroundOpacity;
        const PADDING = properties.TEXT_PADDING;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<rect x="${0}" y="${0}" width="${shapeModel.width}" height="${shapeModel.height}" rx="${15}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}"/>`;
        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitTextboxSimple(shapeModel) {
        var textStyle = this.getTextStyle(shapeModel);
        const PADDING = properties.TEXT_PADDING;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;
        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitSpeakBubble(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var textStyle = this.getTextStyle(shapeModel);
        const PADDING = properties.TEXT_PADDING;

        var path = speakBubbleUtils.getPath(shapeModel);
        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<rect x="${0}" y="${0}" width="${shapeModel.width}" height="${shapeModel.height}" rx="${15}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}"/>`;
        data = data + `<path d="${path}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitComplexSpeakBubble(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var textStyle = this.getTextStyle(shapeModel);
        const PADDING = properties.TEXT_PADDING;

        var path = speakBubbleUtils.getPath(shapeModel);
        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<rect x="${0}" y="${0}" width="${shapeModel.width}" height="${shapeModel.height}" rx="${15}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}"/>`;

        let pathStrokeWidth = shapeModel.strokeWidth;

        if (pathStrokeWidth < 2 && shapeModel.isMindMap)
            pathStrokeWidth = 2;

        data = data + `<path d="${path}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${pathStrokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + this.getImageNode(shapeModel);

        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitScreamBubble(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var textStyle = this.getTextStyle(shapeModel);
        const PADDING = properties.TEXT_PADDING;

        var path = screamBubbleUtils.getPath(shapeModel);
        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<path d="${path}" filter="${shapeModel.filter}" opacity="${shapeModel.opacity}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitThoughtBubble(shapeModel) {
        var backgroundOpacity;

        if (shapeModel.backgroundVisible == false)
            backgroundOpacity = 0;
        else
            backgroundOpacity = 1;

        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var textStyle = this.getTextStyle(shapeModel);
        const PADDING = properties.TEXT_PADDING;

        var path = thoughtBubbleUtils.getPath(shapeModel);
        let stemObject = thoughtBubbleUtils.getStemPoints(shapeModel);
        let points = stemObject.points;
        let radius = stemObject.radius;

        var data = this.basicShape(shapeModel);

        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        data = data + `<ellipse rx="${radius[0]}" ry="${radius[0]}" cx="${points[0].x}" cy="${points[0].y}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;
        data = data + `<ellipse rx="${radius[1]}" ry="${radius[1]}" cx="${points[1].x}" cy="${points[1].y}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;
        data = data + `<ellipse rx="${radius[2]}" ry="${radius[2]}" cx="${points[2].x}" cy="${points[2].y}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;
        data = data + `<path d="${path}" filter="${shapeModel.filter}" fill="${shapeModel.fill}" fill-opacity="${backgroundOpacity}" stroke="${shapeModel.stroke}" stroke-width="${shapeModel.strokeWidth}" stroke-opacity="${shapeModel.strokeOpacity}" preserveAspectRatio="none" />`;

        data = data + `<foreignObject x="${PADDING}" y="${PADDING}" width="${shapeModel.width - 2 * PADDING}" height="${shapeModel.height - 2 * PADDING}">`;

        if (shapeModel.isRichText)
            data = data + `<div style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(textSizeUtils.getHtmlText(shapeModel))}</div>`;
        else
            data = data + `<textarea style="${textStyle}" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">${this.encodeText(shapeModel.htmlText)}</textarea>`;

        data = data + `</foreignObject ></g></g></g></g>`;

        return data;
    },
    visitGroup(shapeModel) {
        var opacityValue = shapeModel.opacity;

        if (shapeModel.animation && shapeModel.animation.start_opacity >=0 && shapeModel.animation.end_opacity >=0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity)
            opacityValue = 1;

        var data = this.basicShape(shapeModel);
        data = data + `<g x="0" y="0" opacity="${opacityValue}">`;

        var shapesData = this.getHtmlFromShapes(shapeModel.shapes, true).layers[0];
        data = data + shapesData;

        data = data + '</g></g></g></g>';

        return data;
    },
    visitVideo(shapeModel) {

    }
};

export default exporterUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ExporterUtils.js
 **/